import AbsCategories from "./AbsCategories";

class CategoriesSkill extends AbsCategories {
    constructor(_store={}, _router={}, _el=''){
        super('class CategoriesSkill', _store, _router, _el);
    }

    subInit(){
        let watchRaceId = this.watch(this.store.getState, 'selRaceId', this.isEqual);
        this.store.subscribe( watchRaceId( (newVal, oldVal, path) => this.setActive( this.store.getState().selRaceId, this.store.getState().selClassId ) ) );

        let watchClassId = this.watch(this.store.getState, 'selClassId', this.isEqual);
        this.store.subscribe( watchClassId( (newVal, oldVal, path) => this.setActive( this.store.getState().selRaceId, this.store.getState().selClassId ) ) );
    }

    addEvents(){
        $( this.el + ' .gd-filter-list li>button.depth1' ).on('click', (e)=>{
            this.router.goMultiParamSetListPage( {
                'raceid':  $(e.currentTarget).data('raceid'),
                'classid': ''
            });
        });
        
        $( this.el + ' .gd-filter-list li>button.depth2' ).on('click', (e)=>{
            this.router.goMultiParamSetListPage( {
                'classid':  $(e.currentTarget).data('classid')
            } );
        });

        $( this.el + ' button.gd-filter-list-title' ).on('click', (e)=>{
            // this.store.dispatch( this.actions.setStopListLoad(true) );
            // this.store.dispatch( this.actions.setListpage( 1 ) );
            this.router.goMultiParamSetListPage( {
                'raceid': '',
                'classid': ''
            });
            // this.store.dispatch( this.actions.setStopListLoad(false) );
            // this.store.dispatch( this.actions.loadItemList(1) );
        });
    }

    setActive(){
        let d1 = this.store.getState().selRaceId;
        let d2 = this.store.getState().selClassId;
        $( this.el + ' .gd-filter-list li' ).removeClass('is-active');
        $( this.el + ' button.gd-filter-list-title' ).removeClass('is-active');
        if ((d1===null || d1==='') && (d2===null || d2==='')) {
            $( this.el + ' button.gd-filter-list-title' ).addClass('is-active');
            return false;
        }
        if(d1!==null && d1!==''){
            $( this.el + ' .gd-filter-list' ).find(`li[data-raceid=${d1}]`).addClass('is-active');
        }
        if(d2!==null && d2!==''){
            $( this.el + ' .gd-filter-list-inner' ).find(`li[data-classid=${d2}]`).addClass('is-active');
        }
    }





} // end of class
export default CategoriesSkill;